import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import Chip from "@mui/material/Chip";
import { getCurrency } from "@common/contracts";
import { Grid, Typography } from "@mui/material";
import { textColor } from "../../../../assets/styles/colors";
const checkIfProductIsOnSale = (product) => {
    if (!product.sale)
        return false;
    if (!product.saleStartDate && !product.saleStopDate)
        return true;
    const date = new Date();
    if (!product.saleStopDate)
        return (product.saleStartDate?.getTime() || 0) < date.getTime();
    if (!product.saleStartDate)
        return (product.saleStopDate?.getTime() || 0) > date.getTime();
    return (((product.saleStartDate?.getTime() || 0) < date.getTime())
        &&
            ((product.saleStopDate?.getTime() || 0) > date.getTime()));
};
const ShowPrice = ({ product: { price }, isProductOnSale, onClick }) => {
    if (!price)
        return null;
    return (_jsx(Grid, { item: true, children: _jsx(Chip, { label: `${getCurrency(price.currency)?.symbol || ""}${price.amount.toFixed(2)}`, color: isProductOnSale ? "error" : "primary", sx: isProductOnSale ? { textDecoration: 'line-through' } : undefined, onClick: onClick }, void 0) }, void 0));
};
const ShowSale = ({ product: { sale, saleStopDate }, isProductOnSale, untilMsg, onClick }) => {
    if (!isProductOnSale)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, children: _jsx(Chip, { label: `${getCurrency(sale?.currency)?.symbol || ""}${sale?.amount.toFixed(2)}`, color: "primary", onClick: onClick }, void 0) }, void 0), (untilMsg && saleStopDate) ?
                _jsx(Grid, { item: true, children: _jsxs(Typography, { variant: "caption", display: "block", gutterBottom: true, sx: { color: textColor, whiteSpace: "pre-wrap", margin: 0 }, children: ["until ", saleStopDate.toLocaleDateString()] }, void 0) }, void 0)
                : null] }, void 0));
};
export const ShowPrices = ({ product, untilMsg, onClick }) => {
    const isProductOnSale = useMemo(() => checkIfProductIsOnSale(product), [product]);
    if (!product.price && !product.sale)
        return null;
    return (_jsxs(Grid, { container: true, spacing: 1, alignItems: 'center', children: [_jsx(ShowPrice, { product: product, isProductOnSale: isProductOnSale, onClick: onClick }, void 0), _jsx(ShowSale, { product: product, isProductOnSale: isProductOnSale, untilMsg: untilMsg, onClick: onClick }, void 0)] }, void 0));
};
//# sourceMappingURL=ShowPrice.js.map